import _isArray from "lodash/isArray";

var normalizeHandlers = function normalizeHandlers(handlers) {
  return _isArray(handlers) ? handlers : [handlers];
};

export default normalizeHandlers;


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/lib/eventStack/normalizeHandlers.js
// module id = 781
// module chunks = 0